export interface AnnualEIT107040List {
        row?: string,
        name?: string,
        amount?: string,
        indent?: number,
        rowspan?: number,
        isEdit?: boolean,
        rowName?:string,
}

let list: AnnualEIT107040List[] = [
        {
                name: "一、符合条件的小型微利企业减免企业所得税",
                row: "1",
                amount: "",
                indent: 0,
                isEdit: true,
                rowName:"1",
        },
        {
                name: "二、国家需要重点扶持的高新技术企业减按15%的税率征收企业所得税（填写A107041）",
                row: "2",
                amount: "",
                indent: 2,
                isEdit: false,
                rowName:"2",
        },
        {
                name: "三、经济特区和上海浦东新区新设立的高新技术企业在区内取得的所得定期减免企业所得税（填写A107041）",
                row: "3",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"3",
        },
        {
                name: "四、受灾地区农村信用社免征企业所得税（4.1+4.2）",
                row: "4",
                amount: "",
                indent: 0,
                isEdit: true,
                rowName:"4",
        },
        {
                name: "（一）芦山受灾地区农村信用社免征企业所得税",
                row: "4.1",
                amount: "",
                indent: 2,
                isEdit: false,
                rowName:"4a",
        },
        {
                name: "（二）鲁甸受灾地区农村信用社免征企业所得税",
                row: "4.2",
                amount: "",
                indent: 2,
                isEdit: false,
                rowName:"4b",
        },
        {
                name: "五、动漫企业自主开发、生产动漫产品定期减免企业所得税",
                row: "5",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"5",
        },
        {
                name: "六、线宽小于0.8微米（含）的集成电路生产企业减免企业所得税（填写A107042）",
                row: "6",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"6",
        },
        {
                name: "七、线宽小于0.25微米的集成电路生产企业减按15%税率征收企业所得税（填写A107042）",
                row: "7",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"7",
        },
        {
                name: "八、投资额超过80亿元的集成电路生产企业减按15%税率征收企业所得税（填写A107042）",
                row: "8",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"8",
        },
        {
                name: "九、线宽小于0.25微米的集成电路生产企业减免企业所得税（填写A107042）",
                row: "9",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"9",
        },
        {
                name: "十、投资额超过80亿元的集成电路生产企业减免企业所得税（填写A107042）",
                row: "10",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"10",
        },
        {
                name: "十一、新办集成电路设计企业减免企业所得税（填写A107042）",
                row: "11",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"11",
        },
        {
                name: "十二、国家规划布局内集成电路设计企业可减按10%的税率征收企业所得税（填写A107042）",
                row: "12",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"12",
        },
        {
                name: "十三、符合条件的软件企业减免企业所得税（填写A107042）",
                row: "13",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"13",
        },
        {
                name: "十四、国家规划布局内重点软件企业可减按10%的税率征收企业所得税（填写A107042）",
                row: "14",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"14",
        },
        {
                name: "十五、符合条件的集成电路封装、测试企业定期减免企业所得税（填写A107042）",
                row: "15",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"15",
        },
        {
                name: "十六、符合条件的集成电路关键专用材料生产企业、集成电路专用设备生产企业定期减免企业所得税（填写A107042）",
                row: "16",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"16",
        },
        {
                name: "十七、经营性文化事业单位转制为企业的免征企业所得税",
                row: "17",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"17",
        },
        {
                name: "十八、符合条件的生产和装配伤残人员专门用品企业免征企业所得税",
                row: "18",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"18",
        },
        {
                name: "十九、技术先进型服务企业减按15%的税率征收企业所得税",
                row: "19",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"19",
        },
        {
                name: "二十、服务贸易创新发展试点地区符合条件的技术先进型服务企业减按15%的税率征收企业所得税",
                row: "20",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"20",
        },
        {
                name: "二十一、设在西部地区的鼓励类产业企业减按15%的税率征收企业所得税",
                row: "21",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"21",
        },
        {
                name: "二十二、新疆困难地区新办企业定期减免企业所得税",
                row: "22",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"22",
        },
        {
                name: "二十三、新疆喀什、霍尔果斯特殊经济开发区新办企业定期免征企业所得税",
                row: "23",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"23",
        },
        {
                name: "二十四、广东横琴、福建平潭、深圳前海等地区的鼓励类产业企业减按15%税率征收企业所得税",
                row: "24",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"24",
        },
        {
                name: "二十五、北京冬奥组委、北京冬奥会测试赛赛事组委会免征企业所得税",
                row: "25",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"25",
        },
        {
                name: "二十六、享受过渡期税收优惠定期减免企业所得税",
                row: "26",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"26",
        },
        {
                name: "二十七、其他",
                row: "27",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"27",
        },
        {
                name: "二十八、减：项目所得额按法定税率减半征收企业所得税叠加享受减免税优惠",
                row: "28",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"28",
        },
        {
                name: "二十九、支持和促进重点群体创业就业企业限额减征企业所得税(29.1+29.2)",
                row: "29",
                amount: "",
                indent: 0,
                isEdit: true,
                rowName:"29",
        },
        {
                name: "（一）下岗失业人员再就业",
                row: "29.1",
                amount: "",
                indent: 2,
                isEdit: false,
                rowName:"29a",
        },
        {
                name: "（二）高校毕业生就业",
                row: "29.2",
                amount: "",
                indent: 2,
                isEdit: false,
                rowName:"29b",
        },
        {
                name: "三十、扶持自主就业退役士兵创业就业企业限额减征企业所得税",
                row: "30",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"30",
        },
        {
                name: "三十一、民族自治地方的自治机关对本民族自治地方的企业应缴纳的企业所得税中属于地方分享的部分减征或免征（□免征     □减征:减征幅度____%  ）",
                row: "31",
                amount: "",
                indent: 0,
                isEdit: false,
                rowName:"31",
        },
        {
                name: "合计（1+2+…+26+27-28+29+30+31）",
                row: "32",
                amount: "",
                indent: 0,
                isEdit: true,
                rowName:"32",
        },
        
]


let AnnualEIT107040 = list
export default AnnualEIT107040
